import styled, { keyframes } from 'styled-components';

const DotFlashingAnimation = keyframes`
    0% {
        background-color: rgba(32, 154, 214, 1);
    }
    50%,
    100% {
        background-color: rgba(0, 154, 206, 0.2);
    }
`;

export const Snippet = styled.div`
  &::before {
    display: inline-block;
    position: absolute;
    top: 6px;
    left: 6px;
    padding: 0 8px;
    content: attr(data-title);
    font-size: 12px;
    font-family: SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono',
      'Courier New', monospace;
    color: white;
  }
`;

export const Stage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
`;

export const DotFlashing = styled.div`
  position: relative;
  width: 10px;
  height: 10px;
  border-radius: 5px;
  background-color: rgba(32, 154, 214, 1);
  color: rgba(32, 154, 214, 1);
  animation: ${DotFlashingAnimation} 1s infinite linear alternate;
  animation-delay: 0.5s;
  &::before,
  &::after {
    content: '';
    display: inline-block;
    position: absolute;
    top: 0;
  }
  &::before {
    left: -15px;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: rgba(32, 154, 214, 1);
    color: rgba(32, 154, 214, 1);
    animation: ${DotFlashingAnimation} 1s infinite alternate;
    animation-delay: 0s;
    content: '';
    display: inline-block;
    position: absolute;
    top: 0;
  }
  &::after {
    left: 15px;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: rgba(32, 154, 214, 1);
    color: rgba(32, 154, 214, 1);
    animation: ${DotFlashingAnimation} 1s infinite alternate;
    animation-delay: 1s;
  }
`;
